<div class="recurrence-panel">

    <div class="panel-header">
        <span class="material-icons-outlined">event_repeat</span>
        <span class="panel-title">{{ "recurrence.change.title" | translate }}</span>
    </div>

    <div class="panel-body" *ngIf="!loading; else busy">

        <p class="intro">
            {{ "recurrence.change.intro" | translate: { count: count, touched: touched } }}
        </p>

        <ul class="affected">
            <!-- every cell is always rendered, empty or not: the columns only
                 line up across the rows if each row fills all five of them -->
            <li *ngFor="let one of (impact | async)?.future" [class.moves]="!one.fits">
                <!-- the number alone: the word would be the same word on every
                     row, and the column is narrow enough already -->
                <span class="occurrence">
                    {{ one.sequence }}<ng-container *ngIf="!seriesUnbounded"> {{
                    "recurrence.details.of" | translate }} {{ seriesTotal }}</ng-container>
                </span>
                <span class="title">{{ one.title }}</span>
                <span class="notes">
                    <span class="note" *ngIf="isCurrent(one.ticketId)">
                        {{ "recurrence.change.thisTicket" | translate }}
                    </span>
                    <span class="note" *ngIf="!one.fits">
                        {{ "recurrence.change.doesNotFit" | translate }}
                    </span>
                </span>
                <span class="scheduled">{{ one.scheduledOn }}</span>
                <span class="warning">
                    <span class="material-icons-outlined" *ngIf="one.hasActivity"
                          [title]="'recurrence.change.hasActivity' | translate">warning</span>
                </span>
            </li>
        </ul>

        <div class="choices">
            <label class="option" [class.on]="choice === 'AFTER_WORKED'">
                <input type="radio" name="onChange" value="AFTER_WORKED" [(ngModel)]="choice" />
                <span *ngIf="!unbounded">
                    {{ "recurrence.change.afterWorked" | translate:
                        { sequence: resumeAfterSequence, total: total, date: resumeAfterDate } }}
                </span>
                <span *ngIf="unbounded">
                    {{ "recurrence.change.afterWorkedUnbounded" | translate:
                        { sequence: resumeAfterSequence, date: resumeAfterDate } }}
                </span>
            </label>

            <label class="option" [class.on]="choice === 'REPLAN_KEEP'">
                <input type="radio" name="onChange" value="REPLAN_KEEP" [(ngModel)]="choice" />
                <span>{{ "recurrence.change.replanKeep" | translate }}</span>
            </label>

            <label class="option" [class.on]="choice === 'REPLAN_DELETE'">
                <input type="radio" name="onChange" value="REPLAN_DELETE" [(ngModel)]="choice" />
                <span>{{ "recurrence.change.replanDelete" | translate }}</span>
            </label>
        </div>

        <p class="warning-note" *ngIf="choice === 'REPLAN_DELETE' && touched > 0">
            {{ "recurrence.change.deleteWarning" | translate }}
        </p>

        <div class="panel-actions">
            <button type="button" class="btn-abort" (click)="abort()">
                {{ "recurrence.change.abort" | translate }}
            </button>
            <button type="button" class="btn-confirm" (click)="confirm()">
                {{ "recurrence.change.confirm" | translate }}
            </button>
        </div>
    </div>

    <ng-template #busy>
        <p class="panel-body">{{ "recurrence.change.loading" | translate }}</p>
    </ng-template>
</div>
